import { getMonth } from "date-fns";

export const isCurrentMonth = (monthNumber: string): boolean => {
  const validMonthNumber = Math.max(1, Math.min(12, Number(monthNumber)));
  return validMonthNumber === getMonth(new Date()) + 1;
};
